( function () {
	'use strict';

	function licensesFactory ( $q, apiService, Session ) {
		function getUserLicenses () {
			return apiService.getUserLicenses.query( {
				'userId' : Session.getCredentials().userId
			} ).$promise;
		}

		var service = {
			'getUserLicenses' : getUserLicenses
		};

		return service;
	}

	angular.module( 'app.login' )
		.factory( 'licensesFactory', licensesFactory );
} )( );
